module.exports = __webpack_public_path__ + "img/Fatdaddy fried chicken.56741abf.svg";